<template>
  <div id="leaves">
    <i v-for="index in count" :key="index"></i>
  </div>
</template>

<script>
import '@/styles/leaves.scss';

export default {
  name: 'Leaves',
  data() {
    return {
      windowWidth: window.innerWidth,
      leafWidth: 30,
    };
  },
  computed: {
    count() {
      return Math.floor(this.windowWidth / this.leafWidth);
    },
  },
};
</script>
